<template>
    <vx-card :title="pageTitle" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/4 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label"> Интервал </label>
                    <date-picker
                        range
                        v-model="dateInterval"
                        :not-before="disabledBefore"
                        :shortcuts="[]"
                        type="date"
                        format="YYYY-MM-DD"
                        placeholder="Интервал времени события"
                        :lang="'ru'"
                        :firstDayOfWeek="1"
                        class="date-p w-full"
                    >
                    </date-picker>
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label"> SSP </label>
                    <v-select
                        :options="dicts.sspTypes"
                        label="name"
                        placeholder="Выберите SSP"
                        class="w-full"
                        v-model="form.sspId"
                        :reduce="(s) => s.id"
                    >
                    </v-select>
                </div>
            </div>

            <div class="vx-col w-1/3 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label"> группы SSP </label>
                    <v-select
                        multiple
                        :options="dicts.sspGroups"
                        label="name"
                        placeholder="Выберите группу"
                        class="w-full"
                        v-model="form.sspGroups"
                        :reduce="(s) => s.id"
                    >
                    </v-select>
                </div>
            </div>            
           
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/4 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label"> Страны </label>
                    <v-select :options="dicts.countries" label="name" placeholder="Выберите страны" class="w-full" v-model="form.country"> </v-select>
                </div>
            </div>

            <div class="vx-col w-1/6 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label"> Тип баинга </label>
                    <v-select
                        clearable
                        multiple
                        :options="dicts.buyingTypes"
                        label="name"
                        placeholder="Выберите тип баинга"
                        class="w-full"
                        v-model="form.buyingTypes"
                        :reduce="(s) => s.id"
                    >
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/6 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label"> Тип объявления </label>
                    <v-select
                        clearable
                        multiple
                        :options="dicts.adTypes"
                        label="name"
                        placeholder="Выберите тип объявления"
                        class="w-full"
                        v-model="form.adTypes"
                        :reduce="(s) => s.id"
                    >
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/6 mb-1">
                <div class="mt-5">
                    <label class="vs-input--label"> Бренд (DSP) </label>
                    <v-select
                        clearable
                        multiple
                        :options="dicts.brandTypes"
                        label="name"
                        placeholder="Выберите бренд"
                        class="w-full"
                        v-model="form.brandTypes"
                    >
                    </v-select>
                </div>
            </div>
            <div class="vx-col w-1/6 mb-1">
                <div class="mt-6">
                    <vs-button class="mt-5" color="success" @click="get(true)" type="filled"> Получить </vs-button>
                </div>
            </div>
        </div>
        <vs-table :data="stats" :max-items="pageSize" stripe pagination class="mt-5">
            <template slot="header"> </template>
            <template slot="thead">
                <vs-th sort-key="adTagId" class="vs-lg-2"> ID тега </vs-th>
                <vs-th sort-key="ctr" class="vs-lg-2"> CTR </vs-th>
                <vs-th sort-key="cpc" class="vs-lg-2"> CPC </vs-th>
                <vs-th sort-key="clicks" class="vs-lg-2"> Количество кликов </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>[{{ tr.adTagId }}] {{ tr.adTagName }}</vs-td>
                    <vs-td>{{ tr.ctr | formatNumber(2) }}</vs-td>
                    <vs-td>{{ tr.cpc | formatNumber(2) }}</vs-td>
                    <vs-td>{{ tr.clicks }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <!-- <vs-pagination :max="5" :total="pagesTotal" v-model="page" class="mt-3"></vs-pagination> -->
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import qs from 'qs';
import axios from 'axios';

const buyoutsDays = 7;

export default {
    name: 'accounting-tags',
    data() {
        return {
            pageTitle: 'Популярные тематики',
            stats: [],
            dateInterval: undefined,
            disabledBefore: this.$moment().add(-buyoutsDays, 'days').startOf('days'),
            form: {
                date_time_from: undefined,
                date_time_to: undefined,
                sspId: undefined,
                sspGroups: undefined,
                country: undefined,
                buyingTypes: undefined,
                brandTypes: undefined,
                adTypes: undefined
            },
            dicts: {
                adTypes: [],
                sspTypes: [],
                sspGroups: [],
                countries: [],
                buyingTypes: [],
                brandTypes: []
            },

            page: 1,
            pageSize: 25,
            pagesTotal: 1
        };
    },
    mounted() {
        this.loadDicts();
        this.setDefaultValues();
        this.get(true);
    },
    methods: {
        loadDicts() {
            this.axios.get('accounting/ad-tags/dicts').then((dicts) => {
                this.dicts.sspTypes = dicts.data.sspTypes;
                this.dicts.sspGroups = dicts.data.sspGroups;
                this.dicts.countries = dicts.data.countries;
                this.dicts.buyingTypes = dicts.data.buyingTypes;
                this.dicts.brandTypes = dicts.data.brandTypes;
                this.dicts.adTypes = dicts.data.adTypes;
            });
        },
        get(reset) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            if (reset) {
                this.page = 1;
            }

            console.log(this.form);

            const params = {
                dateFrom: this.form.date_time_from,
                dateTo: this.form.date_time_to,
                sspId: this.form.sspId,
                SspGroupIds: this.form.sspGroups,
                countryIso2: this.form.country ? this.form.country.iso2 : '',
                buyingTypeIds: this.form.buyingTypes,
                brandTypeIds: this.form.brandTypes ? this.form.brandTypes.map((brandType) => brandType.id) : undefined,
                adTypeIds: this.form.adTypes,
                // page: this.page,
                // size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('accounting/ad-tags', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    })
                    // this.axios.get('dmp/analyze/count', {
                    //     params: params,
                    //     paramsSerializer: (params) => {
                    //         return qs.stringify(params);
                    //     }
                    // })
                ])
                .then(
                    axios.spread((stats /*, count*/) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.stats = stats.data;
                        // this.pagesTotal = Math.ceil(count.data / this.pageSize);
                        this.pagesTotal = 1;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки тегов объявлений.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        setDefaultValues() {
            let endDay = this.$moment(new Date()).add(-1, 'days');
            let endDayStr = endDay.format('YYYY-MM-DD ');
            let startDay = endDay;
            let startDayStr = startDay.format('YYYY-MM-DD ');
            let startTime = '00:00:00';
            let endTime = '23:59:59';
            this.dateInterval = [startDayStr + startTime, endDayStr + endTime];
            this.form.date_time_from = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD');
            this.form.date_time_to = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD');
        }
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    watch: {
        page: function () {
            this.get();
        },
        dateInterval: function (newTime) {
            this.form.date_time_from = this.$moment(newTime[0]).format('YYYY-MM-DD');
            this.form.date_time_to = this.$moment(newTime[1]).format('YYYY-MM-DD');
        }
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Популярные тематики';
    }
};
</script>

<style>
.date-p {
    display: block;
}
.b-btn {
    border-radius: 0;
    width: 200px;
}
.vs-pagination--mb {
    justify-content: center !important;
}
</style>